export enum SmartViewClickSource {
  SMART_VIEWS_CONTENT = 'smart_views_content',
  SMART_VIEWS_SETTINGS = 'smart_views_settings',
}

export enum SmartViewAnalytics {
  SWITCH_SELECTED_TAB = 'smart_views_switch_selected_tab',
  AUTO_SELECTED_TAB = 'smart_views_auto_selected_tab',
  VIEW_TAB_DETAILS = 'smart_views_view_tab_details',
  CLICK_REFRESH_DATA = 'smart_views_click_refresh_data',
  CLICK_ADD_SMART_VIEW = 'smart_views_click_add_smart_view',
  CLICK_MODIFY_SMART_VIEW_SUBMIT = 'smart_views_click_modify_smart_view_submit',
  CLICK_SET_CONDITIONS = 'smart_views_click_set_conditions',
}

export const BreadcrumbAnalytics = {
  CLICK_BREADCRUMB_ITEM: 'breadcrumb_click_breadcrumb_item',
};

export const DashboardHeaderAnalytics = {
  CLICK_LOGO: 'dashboard_header_click_logo',
  CLICK_NAVIGATION_ITEM: 'dashboard_header_click_navigation_item',
  CLICK_HAMBURGER_MENU: 'dashboard_header_click_hamburger_menu',
};

export const DashboardHeaderClickSource = {
  HEADER: 'dashboard_header',
};

export const CallInsightsAnalytics = {
  EXPAND_CALL_INSIGHTS: 'call_insights_expand',
  AI_FEEDBACK: 'ai_call_insights_feedback',
};

export const LeadDetailClickSource = {
  SUB_HEADER: 'lead_detail_sub_header',
  RIGHT_PANEL: 'lead_detail_right_panel',
  ACTIVITIES_TAB: 'lead_detail_activities_tab',
  PROPERTIES_TAB: 'lead_detail_properties_tab',
  LEFT_PANEL: 'lead_detail_left_panel',
  NOTES_AND_TASKS_TAB: 'lead_detail_notes_and_tasks_tab',
  ACTIVITIES_SUMMARY_DRAWER: 'lead_detail_activities_summary_drawer',
};

export enum LeadDetailAnalytics {
  CLICK_ADD_ACTIVITY = 'click_add_activity_button',
  OPEN_ACTIVITY_DETAILS = 'open_activity_details',
  CLOSE_ACTIVITY_DETAILS = 'close_activity_details',
  CLICK_ADD_NOTE = 'click_add_note_button',
  SUBMIT_NOTE = 'submit_note',
  CLICK_ADD_TASK = 'click_add_task_button',
  SELECT_TASK_TEMPLATE = 'select_task_template',
  UPDATE_TASK_STATUS = 'update_task_status',
  FILTER_ACTIVITIES = 'filter_activities',
  FILTER_ACTIVITIES_TIME = 'filter_activities_time',
  CLICK_EDIT_LEAD_DETAILS = 'click_edit_lead_details',
  UPDATE_LEAD_DETAILS = 'update_lead_details',
  OPEN_PROCESS_FORM = 'open_process_form',
  SWITCH_TAB = 'lead_detail_switch_tab',
  SWITCH_ACTIVITIES_VIEW_MODE = 'switch_activities_view_mode',
  CLICK_RECENT_ACTIVITY = 'click_recent_activity',
  CLICK_ACTIVITY_SUMMARY_COUNT = 'click_activity_summary_count',
  CLICK_ACTIVITY_IN_DRAWER = 'click_activity_in_drawer',
}

export enum QuickFilterAnalytics {
  CLICK_APPLY_FILTER = 'quick_filter_click_apply_filter',
}

export enum QuickFilterAnalyticsSources {
  ORG_LEVEL_FILTER = 'org_level_filter',
  USER_LEVEL_FILTER = 'user_level_filter',
}

export enum ManageLeadsAnalytics {
  CLICK_UPDATE_VISIBLE_COLUMNS = 'manage_leads_click_update_visible_columns',
}

export const ManageLeadsClickSource = {
  MANAGE_LEADS_PAGE: 'manage_leads_page',
};
